import { API_BASE_URL } from "./config";

export const getContact = () => {
  return fetch(`${API_BASE_URL}/api/v1/contactPage/contact`, {
    method: "GET",
  });
};

export const PostContactMessage = (body) => {
  return fetch(`${API_BASE_URL}/api/v1/message/createMessage`, {
    method: "POST",
    body: body,
  });
};
